import { useTranslation } from 'react-i18next';
import { useFooterStyles } from './Footer.styles';
import { useFooterConfig } from '@/hooks/useFooterConfig';
import type { PrivacyLink } from '@config/footerConfig';

export interface FooterProps {
  config?: { privacyLinks: PrivacyLink[] };
}

export function Footer({ config }: FooterProps): React.JSX.Element {
  const styles = useFooterStyles();
  const { t } = useTranslation('footer');
  const regionConfig = useFooterConfig();
  const effectiveConfig = config ?? regionConfig;
  const year = new Date().getFullYear();

  return (
    <footer className={styles.root} role="contentinfo" aria-label={t('footer.ariaLabel')}>
      <div className={styles.privacyLinks}>
        {effectiveConfig.privacyLinks.map((link) => (
          <a
            key={link.labelKey}
            className={styles.link}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(link.labelKey)}
          </a>
        ))}
      </div>
      <span className={styles.copyrightFull}>{t('footer.copyright', { year })}</span>
      <span className={styles.copyrightShort}>{t('footer.copyrightShort')}</span>
    </footer>
  );
}
